<template>
  <div id='page'>
    <recentMatchTitle v-if='logs.length > 0'/>
    <div v-for="item in logs" :key='item.label'>
      <div class="section-title">{{ item.label }}</div>
      <div v-for="(match, index) in item.list" :key='index'>
        <recentMatchCell :recentMatch='match'/>
        <hr v-if='index != item.list.length - 1'/>
      </div>
    </div>
    <hr v-if='netState == 0'/>
    <loadStateView :state='netState' :refreshHandle="loadData"/>
  </div>
</template>

<script>
import { dateConverter, groupItems, checkEmptyObject } from '@/utils'
import recentMatchCell from './components/recentMatchCell'
import recentMatchTitle from './components/recentMatchTitle'

export default {
  name: 'player-game-logs',
  props: {
    playerId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      logs: []
    }
  },
  components: {
    recentMatchTitle,
    recentMatchCell
  },
  activated () {
    this.loadData()
  },
  watch: {
    playerId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    }
  },
  methods: {
    loadData () {
      this.netState = checkEmptyObject(this.logs) ? 1 : 0
      this.$dataBaseClient.get(`b_player/gameData?playerId=${this.playerId}`)
        .then((response) => {
          this.netState = response.netState

          if (this.netState === 3) {
            this.logs = []
            return
          }

          this.logs = groupItems(response.gameData, (item) => dateConverter(item.gameDate).slice(0, 7))
          console.log(response)
        })
        .catch((error) => {
          this.netState = 2
          console.log(error)
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'

</style>
